import React, { useCallback, useState } from 'react';
import Toast from './Toast';
import './Toast.css';

const MAX_TOASTS = 5;

export function ToastStack({ toasts, onDismiss }) {
  if (!toasts.length) {
    return null;
  }

  return (
    <div className="toast-stack" aria-live="polite" aria-relevant="additions removals">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          isVisible
          stacked
          onClose={() => onDismiss(toast.id)}
          duration={toast.duration ?? 5000}
        />
      ))}
    </div>
  );
}

export function useToastStack(maxToasts = MAX_TOASTS) {
  const [toasts, setToasts] = useState([]);

  const pushToast = useCallback((message, type = 'success', duration = 5000) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    setToasts((prev) => [...prev, { id, message, type, duration }].slice(-maxToasts));
  }, [maxToasts]);

  const dismissToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return { toasts, pushToast, dismissToast };
}

export default ToastStack;
